<div class="relative" [id]="'comment-' + comment.commentId">
  <div
    *ngIf="comment.isFlagged"
    class="absolute top-0 left-0 right-0 bottom-0 z-[1] backdrop-blur-[5px]"
  >
    <div class="flex flex-col items-center translate-y-1/3 h-full">
      <ark-lib-icon-name name="flagged"></ark-lib-icon-name>
      <div class="w-full bg-pink-600 mt-[18px]">
        <div
          class="text-center text-white text-[11px] font-bold uppercase leading-[18px] tracking-wide"
        >
          Reported as illegal content
        </div>
      </div>
    </div>
  </div>
  <div
    class="p-5 flex flex-col border-solid"
    [class.border-[2px]]="comment.isModerated"
    [class.border-[#e5cc6f]]="comment.isModerated"
    [class.bg-[#fff8e0]]="comment.isModerated"
    [class.bg-white]="!comment.isModerated"
  >
    <div class="flex">
      <div class="mr-[6px]">
        <img
          class="w-[50px] h-[50px] rounded-full object-cover"
          [src]="comment?.nft"
        />
      </div>

      <div class="flex justify-between flex-1">
        <div>
          <div
            class="font-medium text-[16px] leading-[26px] text-[#14192D]"
            (click)="onNicknameClick($event)"
          >
            &#64;{{ comment.creatorNickname }}
          </div>
          <div class="text-sm font-normal leading-normal text-[#14192D]">
            {{ comment?.creationDateTime | timeAgo }}
          </div>
        </div>
        <div>
          <ark-lib-wisee
            [marketSectors]="comment.marketSectors"
          ></ark-lib-wisee>
        </div>
      </div>
    </div>

    <div class="text-[#636363] text-base font-normal leading-[21px] mt-3">
      <!-- Edit Mode -->
      <ark-input
      ngDefaultControl
      *ngIf="isEditingComment"
      [label]="'Edit Comment'"
      [placeholder]="'Edit your comment...'"
      [clearOnEnterPressed]="true"
      [actionIcon]="'message-send'"
      [value]="updatedComment"
      [(ngModel)]="updatedComment"
      (keyup.enter)="updateComment()"
      (ngModelChange)="onUpdatedCommentChange($event)"
      (actionIconPressed)="onActionIconClicked($event)"
      [mentionItems]="mentionListNicknames"
      (searchTerm)="onMentionSearch($event)"
    >
      </ark-input>
      
      <!-- View Mode -->
      <div
        *ngIf="!isEditingComment"
        class="text-[#636363] text-base font-normal leading-[21px]"
        [innerHTML]="comment.description | links"
      ></div>


    </div>

    <div *ngIf="comment.isModerated && !comment.isModerationVoteSubmitted && !comment.isMine" class="flex items-center justify-end my-3 cursor-pointer">
      <div (click)="openModerateCommentModal()" class="flex flex-row">
        <ark-lib-icon-name name="gavel"></ark-lib-icon-name>
        <div class="text-slate-900 text-sm font-semibold leading-normal ml-[5px]">
          Moderate
        </div>
     </div>
    </div>

    <div
      class="flex flex-row justify-between mt-3"
    >
      <!-- <div class="flex flex-row items-center">
        <ark-lib-icon-name name="stats"></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] ml-[5px]">
          {{ comment.receivedCount }}
        </div>
      </div> -->

      <div class="flex flex-row items-center">
        <ark-lib-icon-name
          [name]="comment.upVoteMine ? 'like-active' : 'like'"
          (click)="comment.isMine ? null : upvoted.emit(comment)"
        ></ark-lib-icon-name>
        <div
          class="text-black text-[11px] font-normal leading-[18px] mx-[5px] mr-2"
        >
          {{ comment.upVoteCount | numberAbbrevation }}
        </div>
        <ark-lib-icon-name
          [name]="comment.downVoteMine ? 'dislike-active' : 'dislike'"
          (click)="comment.isMine ? null : downvoted.emit(comment)"
        ></ark-lib-icon-name>
        <!-- <div class="text-black text-[11px] font-normal leading-[18px] mx-[5px]">
          {{ comment.downVoteCount | numberAbbrevation }}
        </div> -->
      </div>

      <div class="flex flex-row items-center" (click)="toggleShowReply()">
        <ark-lib-icon-name name="reply"></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] ml-[5px]">
          Reply
        </div>
      </div>

      <div class="flex flex-row items-center" *ngIf="menuOptions.length > 0">
        <ark-lib-proposition-menu *ngIf="this.comment.isMine && !this.comment.isModerated || !this.comment.isMine && this.comment.isModerated || !this.comment.isMine && !this.comment.isModerated"
          [options]="menuOptions"
        ></ark-lib-proposition-menu>
      </div>
    </div>
  </div>

  <!-- <div *ngIf="comment.isModerated"
    class="flex flex-col gap-[5px]"
  >
    <h6
      class="font-bold text-[24px] leading-[32px] text-center"
      >Why is this post inaccurate?</h6>
      <div>{{'@' + comment?.moderatorNickname}} 
        <span 
        class="font-normal text-[14px] leading-[24px] text-[#BEB9B4]"
        >{{comment?.moderationDatetime | date: 'MMM d'}}
        </span>
      </div>
      <div 
      class="font-normal text-[16px] leading-[21px] text-[#636363]"
      >
      {{comment?.moderationReason}}
      </div>
  </div> -->

  <div *ngIf="comment?.replies?.length > 0">
    <div
      class="flex justify-center items-center py-[12px]"
      (click)="toggleReply()"
    >
      <span
        *ngIf="!showReplies"
        class="font-bold text-[13px] leading-[24px] text-[#19142D] mr-[10px]"
        >SHOW {{ comment?.replies.length }} REPLIES</span
      >
      <span
        *ngIf="showReplies"
        class="font-bold text-[13px] leading-[24px] text-[#19142D] mr-[10px]"
        >HIDE REPLIES</span
      >

      <ark-lib-icon-name name="arrow-down"></ark-lib-icon-name>
    </div>
  </div>

  <div *ngIf="showReplies">
    <div *ngIf="showReplyInput">
      <ark-input
        label="Reply"
        placeholder="Reply comment..."
        [clearOnEnterPressed]="true"
        [actionIcon]="'message-send'"
        (enterPressed)="onReply($event)"
        [mentionItems]="mentionListNicknames"
        (searchTerm)="onMentionSearch($event)"
      ></ark-input>
    </div>

    <div>
      <div *ngFor="let reply of comment?.replies">
        <div
          class="border-solid border-l-[3px] border-[#E6E1D7] mb-[10px]"
        >
          <div *ngIf="reply.isEditing; else viewMode">
            <ark-input
              ngDefaultControl
              [label]="'Edit Reply'"
              [placeholder]="'Edit your reply...'"
              [value]="getPlainText(reply.description)"
              [(ngModel)]="updatedReply"
              [clearOnEnterPressed]="true"
              [actionIcon]="'message-send'"
              (actionIconPressed)="updateReply(reply.commentReplyId ?? reply.commentIdeaReplyId)"
              (keyup.enter)="updateReply(reply.commentReplyId  ?? reply.commentIdeaReplyId)"
              [mentionItems]="mentionListNicknames"
              (searchTerm)="onMentionSearch($event)"
            ></ark-input>
          </div>
          <ng-template #viewMode>
            <ark-lib-reply
              [item]="reply"
              (downvoted)="downvotedReply.emit($event)"
              (upvoted)="upvotedReply.emit($event)"
              (editReply)="onEditReply($event)"
              (replyDeleted)="OnReplyDeleted()"
              [entityType]="entityType"
            ></ark-lib-reply>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
